module.exports = __webpack_public_path__ + "static/img/testimony (69).b9985e28.jpg";